/* RESPONSIBLE TEAM: team-channels */
import { helper as buildHelper } from '@ember/component/helper';
import { isValidUrlWithProtocol } from 'embercom/lib/url-validator';

export interface IsValidUrlSignature {
  Args: {
    Positional: [string | null | undefined];
  };
  Return: boolean;
}

export function isValidUrl(params: [string | null | undefined]) {
  let url = params[0];
  if (!url || typeof url !== 'string' || url.trim() === '') {
    return false;
  }
  return Boolean(isValidUrlWithProtocol(url));
}

const helper = buildHelper<IsValidUrlSignature>(isValidUrl);
export default helper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'is-valid-url': typeof helper;
  }
}
